import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Assignment, AuthenticationMethod, ClientInfo } from '../model';
import { UserChoiceData } from '../model/user-choice-data';

@Injectable()
export class AuthenticationService {
  private http = inject(HttpClient);

  private apiUrl = '/api/authn/';

  public getMethods(idp: string, id: string): Observable<AuthenticationMethod[]> {
    const headers = new HttpHeaders().set('xhr', 'true').set('id', id);

    return this.http.get<AuthenticationMethod[]>(`${this.apiUrl}${idp}/methods`, { headers });
  }

  public getClientInfo(idp: string): Observable<ClientInfo> {
    const headers = new HttpHeaders().set('xhr', 'true');

    return this.http.get<ClientInfo>(`${this.apiUrl}${idp}/client-info`, { headers });
  }

  public getAssignments(id: string, idp: string): Observable<Assignment[]> {
    const headers: HttpHeaders = new HttpHeaders().set('xhr', 'true').set('id', id);

    return this.http.get<Assignment[]>(`${this.apiUrl}${idp}/assignments`, { headers }).pipe(map(response => response));
  }

  public getUserChoices(idp: string, id: string): Observable<UserChoiceData> {
    const headers: HttpHeaders = new HttpHeaders().set('xhr', 'true').set('id', id);

    return this.http.get<UserChoiceData>(`${this.apiUrl}${idp}/user-choices`, { headers });
  }

  public doUserChoice(
    idp: string,
    id: string,
    employeeHsaId?: string,
    commissionHsaId?: string,
    organizationHsaId?: string
  ): void {
    let url = `${this.apiUrl}${idp}/user-choice?id=${id}`;

    if (employeeHsaId) {
      url += `&employeeHsaId=${employeeHsaId}`;
    }

    if (commissionHsaId) {
      url += `&commissionHsaId=${commissionHsaId}`;
    }

    if (organizationHsaId) {
      url += `&organizationHsaId=${organizationHsaId}`;
    }

    window.location.href = url;
  }
}
